var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-container",
    {
      attrs: {
        title: _vm.$t(_vm.lblSetting.profileTitle),
        "search-visible": _vm.searchVisible,
        "add-icon-color": "primary",
        "hide-edit-button": true,
        "hide-add-button": !_vm.coIsManagement,
        emptyBar: true
      },
      on: { add: _vm.handleAdd },
      model: {
        value: _vm.coKeyword,
        callback: function($$v) {
          _vm.coKeyword = $$v
        },
        expression: "coKeyword"
      }
    },
    [
      _c("template", { slot: "sub-nav" }, [_c("profile-nav-bar")], 1),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          attrs: {
            "show-create-another": false,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: _vm.isUserUpdateAction ? "person" : "person_add",
            "icon-type": "icon",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText,
            "hide-default-action": true,
            title: _vm.modalTitle,
            "is-dark-title": "",
            "max-width": _vm.maxWidth
          },
          on: { onRecord: _vm.handleSave, onClose: _vm.handleClose },
          model: {
            value: _vm.dtProfileModalVisible,
            callback: function($$v) {
              _vm.dtProfileModalVisible = $$v
            },
            expression: "dtProfileModalVisible"
          }
        },
        [
          _vm.userActionType === _vm.profileAction.Profile
            ? _c("profile-modal-vertical", { ref: "profile-modal" })
            : _vm.userActionType === _vm.profileAction.Signature
            ? _c("profile-signature-modal-vertical", {
                ref: "profile-signature-modal",
                on: { "change-signature": _vm.handleChangeSignature }
              })
            : _vm.userActionType === _vm.profileAction.CharPb
            ? _c("am-char-problem-modal-vertical", {
                ref: "am-char-problem-modal"
              })
            : _vm.userActionType === _vm.profileAction.Attribute ||
              _vm.userActionType === _vm.profileAction.ATAttribute
            ? _c("am-attribute-modal-vertical", { ref: "am-attribute-modal" })
            : _vm.userActionType === _vm.profileAction.AttachmentType
            ? _c("am-attachment-type-modal-vertical", {
                ref: "am-attachment-type-modal"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userActionType === _vm.profileAction.CharPb &&
          _vm.isAMUpdateAction
            ? _c(
                "template",
                { slot: "action-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#2E038C",
                        flat: "",
                        loading: _vm.dtIsRecording
                      },
                      nativeOn: {
                        click: function($event) {
                          _vm.handleUpdateCharPb(true)
                        }
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.characterProblemToEdit.enabled
                              ? _vm.$t(_vm.lblSetting.btnDisable)
                              : _vm.$t(_vm.lblSetting.btnEnable)
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userActionType === _vm.profileAction.AttachmentType &&
          _vm.isAMUpdateAction
            ? _c(
                "template",
                { slot: "action-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#2E038C",
                        flat: "",
                        loading: _vm.dtIsRecording
                      },
                      nativeOn: {
                        click: function($event) {
                          _vm.handleUpdateAttachmentType(true)
                        }
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.attachmentTypeToEdit.enabled
                              ? _vm.$t(_vm.lblSetting.btnDisable)
                              : _vm.$t(_vm.lblSetting.btnEnable)
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          attrs: {
            "show-create-another": false,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "tune",
            "icon-type": "icon",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText,
            "hide-default-action": true,
            title: _vm.TemplateMaintenanceTitle(),
            "is-dark-title": "",
            "max-width": _vm.maxWidth
          },
          on: {
            onRecord: _vm.handleSaveTemplateMaintenance,
            onClose: _vm.handleClose
          },
          model: {
            value: _vm.dtTemplateMaintenanceModalVisible,
            callback: function($$v) {
              _vm.dtTemplateMaintenanceModalVisible = $$v
            },
            expression: "dtTemplateMaintenanceModalVisible"
          }
        },
        [
          _c("template-maintenance-modal", {
            attrs: {
              isUpdateTemplateMaintenance: _vm.isUpdateTemplateMaintenance,
              templateMaintenanceData: _vm.templateMaintenanceData
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          attrs: {
            "show-create-another": false,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "rule_folder",
            "icon-type": "icon",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText,
            "hide-default-action": true,
            title: _vm.ClosingReasonModalTitle(),
            "is-dark-title": "",
            "max-width": "65vw"
          },
          on: {
            onRecord: _vm.handleSaveClosingReasons,
            onClose: _vm.handleClose
          },
          model: {
            value: _vm.dtClosingReasonsModalVisible,
            callback: function($$v) {
              _vm.dtClosingReasonsModalVisible = $$v
            },
            expression: "dtClosingReasonsModalVisible"
          }
        },
        [
          _c("closing-reasons-modal", {
            attrs: { isUpdate: _vm.isUpdateClosingReason }
          }),
          _vm._v(" "),
          _vm.isUpdateClosingReason
            ? _c(
                "template",
                { slot: "action-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#2E038C",
                        flat: "",
                        loading: _vm.loadingDisabled
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleDisableClosingReasons($event)
                        }
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.closingReason.disabled
                              ? "Activer"
                              : "Désactiver"
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          attrs: {
            "show-create-another": false,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "rule_folder",
            "icon-type": "icon",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText,
            "hide-default-action": true,
            title: _vm.TicketSubstatusModalTitle(),
            "is-dark-title": "",
            "max-width": "65vw"
          },
          on: {
            onRecord: _vm.handleSaveTicketSubstatus,
            onClose: _vm.handleClose
          },
          model: {
            value: _vm.dtTicketSubstatusModalVisible,
            callback: function($$v) {
              _vm.dtTicketSubstatusModalVisible = $$v
            },
            expression: "dtTicketSubstatusModalVisible"
          }
        },
        [
          _c("ticket-substatus-modal", {
            attrs: { isUpdate: _vm.isUpdateTicketSubstatus }
          }),
          _vm._v(" "),
          _vm.isUpdateTicketSubstatus
            ? _c(
                "template",
                { slot: "action-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#2E038C",
                        flat: "",
                        loading: _vm.loadingDisabled
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleDisableTicketSubstatus($event)
                        }
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.ticketSubstatus.disabled
                              ? "Activer"
                              : "Désactiver"
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          attrs: {
            "show-create-another": false,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "rule_folder",
            "icon-type": "icon",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText,
            "hide-default-action": true,
            title: _vm.TicketReasonsModalTitle(),
            "is-dark-title": "",
            "max-width": "65vw"
          },
          on: {
            onRecord: _vm.handleSaveTicketReason,
            onClose: _vm.handleClose
          },
          model: {
            value: _vm.dtTicketReasonsModalVisible,
            callback: function($$v) {
              _vm.dtTicketReasonsModalVisible = $$v
            },
            expression: "dtTicketReasonsModalVisible"
          }
        },
        [
          _c("ticket-reason-modal", {
            attrs: { isUpdate: _vm.isUpdateTicketReason }
          }),
          _vm._v(" "),
          _vm.isUpdateTicketReason
            ? _c(
                "template",
                { slot: "action-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#2E038C",
                        flat: "",
                        loading: _vm.loadingDisabled
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleDisableTicketReason($event)
                        }
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.ticketReason.disabled ? "Activer" : "Désactiver"
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.dtErrorModalVisible
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleRemoveError }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21a57503", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a57503","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/template.html
// module id = null
// module chunks = 